import { endpointRegistry, formatZodValidationError, RegisteredHttpEndpoint } from '@luminovo/api-contracts';

// A response with thousands of bad rows produced a Zod error too large for Sentry, which dropped the event.
export const MAX_ZOD_ERROR_LENGTH = 2_000;

export function truncate(s: string, maxLength: number): string {
    return s.length > maxLength ? s.slice(0, maxLength) + `\n… (truncated, ${s.length} chars total)` : s;
}

export function composeRuntypeAssertionErrorMessage({
    endpoint,
    url,
    method,
    requestBody,
    responseBody,
    runtypeError,
}: {
    endpoint: string;
    url: string;
    method: string;
    requestBody: unknown;
    responseBody: unknown;
    runtypeError: unknown;
}): string {
    const description = endpointRegistry[endpoint as RegisteredHttpEndpoint]?.description || '';

    return `Schema validation failed!

Endpoint      : ${endpoint}
Description   : ${description}

Error message :
${truncate(formatZodValidationError(runtypeError, { format: 'pretty' }), MAX_ZOD_ERROR_LENGTH)}

Here's the relevant information:

URL           : ${url}
Method        : ${method}
Request Body  :
${requestBody === undefined ? 'None' : truncate(JSON.stringify(requestBody, null, 2), 500)}
Response Body :
${responseBody === undefined ? 'None' : truncate(JSON.stringify(responseBody, null, 2), 500)}
`;
}
